import { render, staticRenderFns } from "./InventoriesSearch.vue?vue&type=template&id=166b0d62&"
import script from "./InventoriesSearch.vue?vue&type=script&lang=js&"
export * from "./InventoriesSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports